var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnseen(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.69L10 4.802l5.25 3.888v1.296L10.916 13.2a1.55 1.55 0 01-1.832 0L4.75 9.986V8.69zM10 3c-.33 0-.65.107-.916.3L3.708 7.286C3.262 7.615 3 8.135 3 8.69v6.56c0 .965.785 1.75 1.75 1.75h10.5c.965 0 1.75-.785 1.75-1.75V8.69c0-.555-.262-1.077-.708-1.405L10.916 3.3A1.55 1.55 0 0010 3z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnseen);
export default ForwardRef;